module.exports = __webpack_public_path__ + "img/measurement-rooms-x.09f6739b.svg";